import { InfoCircleOutlined } from "@ant-design/icons";
import { Button, Image } from "antd";
import { FC, useCallback, useMemo, useState } from "react";
import { truncateWithEllipsis } from "tm-shared/utils";

import { BaseModal } from "@/components/BaseModal";
import { PrimaryText } from "@/components/Typography/Styled";
import { useAppSelector } from "@/hooks/redux";
import { getFileUrl } from "@/utils/file/getFileUrl";

import {
    StyledCameraPreviewOverlay,
    StyledImageWrapper,
    StyledProductItem,
} from "./Styled";

interface CameraPreviewOverlayProps {
    barcode: string;
}

export const CameraPreviewOverlay: FC<CameraPreviewOverlayProps> = ({
    barcode,
}) => {
    const { products } = useAppSelector((s) => s.offline);
    const [isOpenModal, setIsOpenModal] = useState(false);

    const handleCloseModal = useCallback(() => {
        setIsOpenModal(false);
    }, []);

    const handleOpenModal = useCallback(() => {
        setIsOpenModal(true);
    }, []);

    const product = useMemo(() => {
        return Object.values(products).find((p) => p.barcode === barcode);
    }, [products, barcode]);

    if (!product) return null;

    const photo = product.params.image.value[0];

    return (
        <>
            <StyledCameraPreviewOverlay>
                <Button
                    type="default"
                    icon={<InfoCircleOutlined />}
                    onClick={handleOpenModal}
                >
                    <PrimaryText ellipsis>
                        {truncateWithEllipsis(product.name, 30)}
                    </PrimaryText>
                </Button>
            </StyledCameraPreviewOverlay>

            <BaseModal
                open={isOpenModal}
                onClose={handleCloseModal}
                maskClosable={true}
                actions={null}
                centered={false}
                destroyOnHidden={false}
                styles={{
                    mask: {
                        backgroundColor: "transparent",
                    },
                }}
            >
                <StyledProductItem>
                    <StyledImageWrapper>
                        <Image
                            src={getFileUrl(photo)}
                            alt={product.name}
                            preview={false}
                            style={{
                                objectFit: "contain",
                            }}
                        />
                    </StyledImageWrapper>

                    <PrimaryText fontSize={16} textAlign="center">
                        {product.name}
                    </PrimaryText>
                </StyledProductItem>
            </BaseModal>
        </>
    );
};
